import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useNavigate } from "react-router-dom";
import React from "react";
import { Backdrop, CircularProgress, Tooltip } from "@mui/material";
import { useOutletContext } from "react-router-dom";
import GetClientsList from "hooks/clientsList/GetClientsList";
import SearchInput from "components/searchInput";
import DataTable from "comps/Tables/DataTable";
import MDTypography from "components/MDTypography";
import colors from "assets/theme/base/colors";

function ClientsList() {
  const navigate = useNavigate();
  const {
    clients,
    totalLength,
    setPage,
    page,
    setSearch,
    search,
    isLoading,
    setEntriesPerPage,
    entriesPerPage,
  } = GetClientsList();
  const { setIsEdit, setClient } = useOutletContext();
  let { primary } = colors;
  let rows = clients;

  let columns = [
    {
      accessor: "id",
      Header: "Client Id",
      align: "left",
    },
    {
      accessor: "name",
      Header: "Client Name",
      sortable: true,
      align: "left",
      headerAlign: "center",
      Cell: ({ row }) => {
        const name = row?.original?.name;
        const truncatedName =
          name.length > 15 ? name.substring(0, 15) + "..." : name;
        return (
          <Tooltip title={row?.original?.name}>
            <div>{truncatedName}</div>
          </Tooltip>
        );
      },
    },
    {
      accessor: "email",
      Header: "Email",
      sortable: true,
      align: "left",
      headerAlign: "left",
    },
    {
      accessor: "phone",
      Header: "Contact Number",
      align: "center",
      sortable: true,
      headerAlign: "center",
    },
  ];

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <MDBox pb={0} width="100%" px={1} mt={0}>
        {/* <MDTypography color="textColor" ml="1%">
          Clients
        </MDTypography> */}
        <Grid container spacing={1} pb={1} mb={1}
          sx={{
            // flexDirection: { xs: "column", md: "row" },
            // alignItems: { xs: "flex-end", md: "center" },
            borderBottom: `2px solid ${primary.main}`,
          }}
        >
          <Grid
            px={0}
            item
            xs={2}
            md={2}
            display="flex"
            alignItems={"center"}
            flexDirection="row"
            sx={{
              // flexDirection: { xs: "column", md: "row" },
              // alignItems: { xs: "flex-end", md: "center" },
            }}
            gap="15px"
          >
            <MDTypography fontSize="22px" color="black" >
              Clients
            </MDTypography>
          </Grid>
          <Grid
            px={1}
            item
            xs={10}
            md={10}
            display="flex"
            justifyContent="flex-end"
            flexDirection="row"
            sx={{
              flexDirection: { xs: "column", md: "row" },
              alignItems: { xs: "flex-end", md: "center" },
            }}
            gap="15px"
          >
            <MDButton
              variant="contained"
              color="info"
              onClick={() => {
                navigate("/clients/new");
                setClient({});
                setIsEdit({
                  disabled: false,
                  edit: false,
                });
              }}
            >
              + New Client
            </MDButton>
          </Grid>
        </Grid>
        <MDBox display="flex" justifyContent="center">
          <MDBox py={2} mt={1} borderRadius="5px" bgColor="white" width="100%">
            <Grid container spacing={2} pb={1} px={2}>
              <Grid
                px={2}
                item
                xs={12}
                md={12}
                display="flex"
                justifyContent="flex-end"
                flexDirection="row"
                sx={{
                  flexDirection: { xs: "column", md: "row" },
                  alignItems: { xs: "flex-end", md: "center" },
                }}
                gap="15px"
              >
                <SearchInput setSearch={setSearch} search={search} />
                {/* <MDButton
                  variant="contained"
                  color="info"
                  onClick={() => {
                    navigate("/clients/new");
                    setClient({});
                    setIsEdit({
                      disabled: false,
                      edit: false,
                    });
                  }}
                >
                  + New Client
                </MDButton> */}
              </Grid>
            </Grid>
            <DataTable
              table={{ columns, rows }}
              isSorted
              noEndBorder
              entriesPerPage={entriesPerPage}
              canSearch={false}
              tablePage={page}
              navigateRow={"/clients"}
              setTablePage={setPage}
              setEntriesPerPage={setEntriesPerPage}
              totalLength={totalLength}
              pagination={true}
              tableMaxHeight={"calc(100vh - 280px)"}
              tableMinHeight={"calc(100vh - 280px)"}
            />
          </MDBox>
        </MDBox>
      </MDBox>
    </>
  );
}

export default ClientsList;
